import { Component } from '@angular/core';
import { BaseCellRendererComponent } from '@examdojo/ag-grid';
import { connectState } from '@examdojo/angular/util';
import { UserRole } from '@examdojo/models/user';
import { ICellRendererParams } from 'ag-grid-community';
import { map } from 'rxjs';
import { RoleBadgeComponent, RoleBadgeConfig } from '../../shared/role-badge.component';

export interface RoleBadgeCellRendererParams extends ICellRendererParams {
  config?: RoleBadgeConfig;
}

@Component({
  selector: 'exam-cms-role-badge-cell-renderer',
  template: ` <exam-cms-role-badge [role]="state.role" [config]="state.config" /> `,
  standalone: true,
  imports: [RoleBadgeComponent],
})
export class RoleBadgeCellRendererComponent extends BaseCellRendererComponent<
  UserRole,
  unknown,
  RoleBadgeCellRendererParams
> {
  constructor() {
    super();
  }

  readonly state = connectState({
    role: this.value$.pipe(map((role) => (role as UserRole) || 'CONTRIBUTOR')),
    config: this.params$.pipe(map((params) => ({ size: 'sm' as const, showIcon: false, ...params.config }))),
  });
}
